/* eslint-disable */
import services from 'services';
import * as types from './mutation-types';

export default {
  fetchProductsByStore: async ({ commit }) => {
    const list = await services.InventaireService.getProductsByStore();
    commit(types.SET_LIST_PRODUCT, { list: list });
  },
  fetchInventaireByStore: async ({ commit }) => {
    const inventaireHead = await services.InventaireService.getInventaireHeadByStore();
    commit(types.SET_INVENTAIRE_HEAD, { inventaireHead: inventaireHead });
  },
  fetchProductsAverageQtyByStore: async ({ commit }) => {
    const list = await services.InventaireService.getProductsAverageQtyByStore();
    commit(types.SET_LIST_PRODUCT_AVERAGE_QTY, { list: list });
  },
  setQuantityInventory: async ({ commit, rootGetters }, { data }) => {
    const userId = rootGetters['auth/currentUserId'];
    console.log('DEBUG - ', userId);
    const result = await services.InventaireService.setQuantityInventory(data, userId);

    const list = await services.InventaireService.getProductsByStore(data.storeId);
    commit(types.SET_LIST_PRODUCT, { list: list });
    return result;
  },
  fetchInventaireByIdAndStore: async ({ commit }, { inventaireId }) => {
    const list = await services.InventaireService.getInventaireByIdAndStore(inventaireId);
    commit(types.SET_LIST_INVENTAIRE_HISTORY, { list: list });
  },
  validInventaire: async ({ commit, rootGetters }, { inventoryId, storeId }) => {
    const userId = rootGetters['auth/currentUserId'];
    console.log('DEBUG - ', userId);
    const result = await services.InventaireService.validInventaire(inventoryId, storeId, userId);
    const inventaireHead = await services.InventaireService.getInventaireHeadByStore();
    commit(types.SET_INVENTAIRE_HEAD, { inventaireHead: inventaireHead });
    const list = await services.InventaireService.getProductsByStore(storeId);
    commit(types.SET_LIST_PRODUCT, { list: list });
    return result;
  },
};
